var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module1"},[_c('div',{staticClass:"module"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.data.num))]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('div',{staticClass:"p"},[_vm._v(_vm._s(_vm.data.p))]),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30cce537","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/module1.vue
// module id = null
// module chunks = 